import styled from 'styled-components'

export const ColumnLabel = styled.div`
	display: block;
	font-family: ${({ theme }) => theme.font.family.header};
`
